import * as e from "react";
const u = typeof window < "u" ? e.useLayoutEffect : e.useEffect, f = u;
function s(t) {
  const c = e.useRef(t);
  return f(() => {
    c.current = t;
  }), e.useCallback((...n) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, c.current)(...n)
  ), []);
}
export {
  f as a,
  s as u
};
